import EmployeeRecognitionSoftware from "../../components/best/EmployeeRecognitionSoftware";

export { Page }

function Page() {
  return <EmployeeRecognitionSoftware />;
}